<template>
  <div class="ua-flag-schedule">
    <div class="content" v-if="list.length > 0">
      <div v-for="group in list" :key="group.time" class="time-group">
        <div class="time">{{ group.time }}</div>
        <div
          v-for="game in group.games"
          :key="game.id"
          class="game-card"
          @click="goGame(game)"
        >
          <div class="scoreboard">
            <div class="round-badge">{{ game.name || game.roundDescription || '—' }}</div>
            <div class="scoreboard-row">
              <div class="sb-team">
                <img class="sb-badge" :src="filterImage(game.homeTeam.badge, 40, 40, 2)" alt="" />
                <span class="sb-name overflow-text">{{ game.homeTeamAlias || game.homeTeam.name }}</span>
              </div>
              <div class="sb-center">
                <div class="sb-score">
                  <span v-if="game.homeScore >= 0">{{ getRegularScore(game, 'home') }}</span>
                  <span class="sb-dash">{{ (game.homeScore >= 0 && game.awayScore >= 0) ? '—' : 'VS' }}</span>
                  <span v-if="game.awayScore >= 0">{{ getRegularScore(game, 'away') }}</span>
                </div>
                <div class="sb-state">
                  {{ gameStatusMap(game).label }}
                </div>
              </div>
              <div class="sb-team">
                <img class="sb-badge" :src="filterImage(game.awayTeam.badge, 40, 40, 2)" alt="" />
                <span class="sb-name overflow-text">{{ game.awayTeamAlias || game.awayTeam.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="hint">暂无赛程数据</div>

    <div class="match-note">赛事数据统计由组委会提供</div>

    <div class="footer" v-if="rounds.length > 0">
      <div class="footer-box" ref="footer">
        <div
          v-for="item in rounds"
          :key="item.index + (item.id || '')"
          class="item"
          :class="{ selected: item.index === currentRound && (id === null || item.id === id) }"
          @click="goRound(item.index, item.id, item.stages)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMStageGamesByBMMatchId } from '@/api/match'
import { getWeekdayStringByDateString } from '@/utils'
import { QNImageUtil } from '@/utils'
import { goNewVersionPage } from '@/utils/index'

export default {
  name: 'UaFlagSchedulePage',
  data() {
    return {
      matchId: null,
      isGroupRound: 0,
      round: '',
      list: [],
      maxRound: '',
      rounds: [],
      currentRound: undefined,
      match: {},
      id: null
    }
  },
  mounted() {
    this.matchId = this.$route.params.matchId || this.$route.query.matchId
    if (!this.matchId) return
    this.getBMStageGamesByBMMatchId(1)
  },
  methods: {
    getBMStageGamesByBMMatchId(i) {
      const obj = {
        matchId: this.matchId,
        isGroupRound: this.isGroupRound,
        round: this.round,
        stageId: this.id
      }
      if (i === 1) {
        delete obj.isGroupRound
      }
      if (this.id) {
        delete obj.isGroupRound
      }
      getBMStageGamesByBMMatchId(obj).then(res => {
        const data = res.data
        const match = data.match
        const unionMatch = res.data.unionMatch
        document.title = '赛程榜'
        const shareObj = {
          title: match.chineseName.split('_')[0] + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: match.chineseName.split('_')[1] + '/赛程榜',
          image: QNImageUtil.imageView(match.icon)
        }
        this.wxShare(shareObj)

        const games = data.games || []
        this.maxRound = data.maxRound || match.roundCount + match.knockoutRoundCount
        this.isGroupRound = (typeof data.isGroupRound === 'undefined' ? 1 : data.isGroupRound)
        this.id = data.stageId
        this.currentRound = data.round
        this.match = match

        for (let idx = 0; idx < games.length; idx++) {
          if (games.gameNotBegin === 1) {
            games[idx].gameStatus = '未开始'
          } else if (games.gameEnd === 0) {
            games[idx].gameStatus = '进行中'
          } else {
            games[idx].gameStatus = '已结束'
          }
          games[idx].order = idx + 1
        }

        let tag = 0
        if (data.isGroupRound === 0 && (match.knockoutRoundCount === data.round)) {
          tag = 1
        }
        this.list = this.groupGames(games, tag)

        const rounds = []
        if (match.isBangSaiShi === 1 && data.stages.length >= 1) {
          data.stages.forEach((item, index) => {
            for (let i = 1; i <= item.roundCount; i++) {
              let label = item.stageName + '第' + i + '轮'
              if (item.roundAliasList) {
                const obj = item.roundAliasList.find(a => a.round === i) || null
                if (obj) label = obj.alias
              }
              rounds.push({
                index: i,
                id: item.id,
                stages: index,
                name: label
              })
            }
          })
        } else {
          this.currentRound = data.round + String(!data.isGroupRound)
          console.log( this.currentRound);
          
          for (let i = 1; i <= this.maxRound; i++) {
            const isGroupRound = i <= match.roundCount            
            const round = isGroupRound ? i : i - match.roundCount
            const index = ( i <=  match.roundCount ? i : i - match.roundCount) + ( i <=  match.roundCount ? 'false' : 'true')
            rounds.push({
              index,
              name: this.getDefaultRoundDescription(isGroupRound, round, match)
            })
          }
        }
        
        this.rounds = rounds
        console.log(this.rounds, 'this.currentRound');
        
        this.$nextTick(() => {
          if (!this.$refs.footer) return
          const bol = rounds.length === this.currentRound || rounds.length === this.currentRound + 1 || rounds.length === this.currentRound + 2
          if (bol) {
            this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth
          }
          const idx = rounds.findIndex(r => r.id === this.id && r.index === this.currentRound)
          if (idx > -1 && rounds.length > 0) {
            const d = this.$refs.footer.scrollWidth / rounds.length
            const m = d * idx + d / 2
            const pageWidth = document.documentElement.clientWidth || document.body.clientWidth
            const movePX = m - pageWidth / 2
            if (movePX > 0) this.$refs.footer.scrollLeft = movePX
          }
        })
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) return '-敬请期待'
      if (currentTime >= startTime && currentTime <= endTime) return '-激战正酣'
      return '-完美闭幕'
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    getDefaultRoundDescription(isGroupRound, round, match) {
      let description = ''
      if (!isGroupRound) {
        if (round > match.knockoutRoundCount) {
          round = match.knockoutRoundCount
        }
        if (round === match.knockoutRoundCount) {
          description = '决赛'
        } else if (round === match.knockoutRoundCount - 1) {
          description = '半决赛'
        } else {
          description = '1/' + Math.pow(2, match.knockoutRoundCount - round) + '决赛'
        }
      } else {
        if (round > match.roundCount) {
          round = match.roundCount
        }
        const prefix = match.type === 'cup' ? '小组赛 ' : ''
        description = prefix + '第' + round + '轮'
      }
      return description
    },
    goRound(round, id, index) {
      let round2 = round
      if (round.indexOf('false') > -1 || round.indexOf('true') > -1) {
        round = round.replace('false', '').replace('true', '')
      }
      this.id = id || null
      const match = this.match
      if (match.type === 'cup') {
        this.isGroupRound = round2.indexOf('false') > -1 ? 1 : 0
      }
      if (this.id === null) {
        this.round = (round <= match.roundCount ? round : round - match.roundCount)
      } else {
        this.round = round
      }
      if (this.$refs.footer) {
        this.$nextTick(() => {
          if (this.id) {
            const num = this.rounds.findIndex(item => item.stages === index && item.index === round)
            this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * num - (this.$refs.footer.clientWidth / 2)
          } else {
            this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * round - (this.$refs.footer.clientWidth / 2)
          }
        })
      }
      this.getBMStageGamesByBMMatchId()
    },
    groupGames(games, isLastRound) {
      const gameGroupObject = {}
      for (let i = 0; i < games.length; i++) {
        const game = games[i]
        let gameDateStringKey = '比赛时间待定'
        if (game.beginDate) {
          gameDateStringKey = game.beginDate
            .substring(0, 16)
            .replace(/-/g, '/')
            .replace('T', '  ' + getWeekdayStringByDateString(game.beginDate, true) + '  ')
        }
        if (gameGroupObject[gameDateStringKey]) {
          gameGroupObject[gameDateStringKey].push(game)
        } else {
          gameGroupObject[gameDateStringKey] = [game]
        }
      }
      const keys = Object.keys(gameGroupObject)
      const orderedKeys = keys.sort()
      if (isLastRound) orderedKeys.reverse()
      return orderedKeys.map(k => ({ time: k, games: gameGroupObject[k] }))
    },
    // 计算常规时间比分（总分 - 点球 - 加时）
    getRegularScore(game, team) {
      if (!game) return ''
      const scoreKey = team === 'home' ? 'homeScore' : 'awayScore'
      const penaltyKey = team === 'home' ? 'homePenalty' : 'awayPenalty'
      const plusKey = team === 'home' ? 'homePlus' : 'awayPlus'
      const totalScore = typeof game[scoreKey] === 'number' ? game[scoreKey] : (game[scoreKey] ? Number(game[scoreKey]) : -1)
      const penaltyScore = game[penaltyKey] && game[penaltyKey] !== -1 ? Number(game[penaltyKey]) : 0
      const plusScore = game[plusKey] && game[plusKey] !== -1 ? Number(game[plusKey]) : 0
      if (totalScore < 0 || isNaN(totalScore)) return ''
      const regularScore = totalScore - penaltyScore - plusScore
      return regularScore >= 0 ? regularScore : totalScore
    },
    gameStatusMap(game) {
      const liveStatus = game.liveStatus
      let ret = {}
      if (liveStatus) {
        ret = { label: liveStatus.statusLabel }
        if (liveStatus.status === -3 || liveStatus.status === 0 || (liveStatus.status === -1 && liveStatus.statusLabel === '即将直播')) {
          ret.color = '#CF2F30'
          if (liveStatus.status === -3) ret.label = '即将直播'
        } else if ((liveStatus.status === -1 && liveStatus.statusLabel === '比赛进行中') || liveStatus.status === 1) {
          ret.color = '#CF2F30'
          if (liveStatus.status === 1) ret.label = this.$t('match.schedule.text_2')
        } else if (liveStatus.status === 2) {
          ret.color = '#369AD4'
        } else if (liveStatus.status === -1 && (liveStatus.statusLabel === '比赛结束' || liveStatus.statusLabel === '比分录入中')) {
          if (liveStatus.statusLabel === '比赛结束') ret.label = this.$t('match.schedule.text_3')
          ret.color = '#ababab'
        }
      } else if (game.stateDesc) {
        if (game.state === 1) {
          ret.color = '#38906B'
          ret.label = '等待开赛'
        } else if (game.state === 0) {
          ret.color = '#38906B'
          ret.label = '正在报名'
        } else if (game.state === 2) {
          ret.label = game.stateDesc
          ret.color = '#CF2F30'
        } else if (game.state === 3) {
          ret.label = game.stateDesc
        }
      } else {
        if (game.gameNotBegin === 1) {
          ret.color = '#38906B'
          ret.label = this.$t('match.schedule.text_1')
        } else if (game.gameEnd === 0) {
          ret.color = '#CF2F30'
          ret.label = '比赛进行中'
        } else {
          ret.color = '#369AD4'
          ret.label = this.$t('match.schedule.text_3')
        }
      }
      if (liveStatus && liveStatus.statusLabel === '视频录像') {
        ret.label = this.$t('match.schedule.text_4')
      }
      return ret
    },
    goGame(game) {
      if (game.liveStatus && (game.liveStatus.status === 1 || game.liveStatus.status === 2)) {
        goNewVersionPage({ path: 'gameSummary', gameId: game.id })
      } else {
        this.$router.push({ name: 'UaFlagEventDetail', query: { gameId: game.id } })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-schedule {
  min-height: 100%;
  padding: 12px 16px 88px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
}

.time-group {
  margin-bottom: 18px;
}

.time {
  font-size: 12px;
  color: #b4b4bf;
  text-align: center;
  padding: 10px 0;
}

.game-card {
  margin-bottom: 12px;
}

.scoreboard {
  border-radius: 10px;
  background: radial-gradient(70% 197% at 94% 115%, #282831 0%, #D4021A 100%, #DC0019 100%);
  height: 107px;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 0px;
  // padding-top: 10px;
  box-sizing: border-box;
}

.round-badge {
  display:inline-block;
  align-items: center;
  justify-content: center;
  min-width: 62px;
  height: 18px;
  margin: 0 auto 6px;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  color: #fff;
  background: linear-gradient(180deg, #ff7a3d 0%, #ff682c 45%, #e85a24 100%);
  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);
  overflow: hidden;
  white-space: nowrap;
  padding: 0 12px;
}

.scoreboard-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 12px;
  box-sizing: border-box;
}

.sb-team {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.sb-badge {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
}

.sb-name {
  font-size: 13px;
  max-width: 100%;
}

.sb-center {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 4px;
}

.sb-score {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sb-dash {
  font-weight: 500;
  opacity: 0.85;
}

.sb-state {
  margin-top: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

.hint {
  text-align: center;
  padding: 32px 16px;
  font-size: 14px;
  color: #b4b4bf;
}

.match-note {
  font-size: 12px;
  color: #6e6e78;
  text-align: center;
  padding: 16px 8px 8px;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background: #111;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: env(safe-area-inset-bottom, 12px);
}

.footer-box {
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  text-align: center;

  &::-webkit-scrollbar {
    display: none;
  }
}

.item {
  padding: 14px 18px;
  font-size: 14px;
  box-sizing: border-box;
  flex-shrink: 0;
  color: #b4b4bf;
}

.selected {
  color: #ff682c;
  font-weight: 600;
  box-shadow: inset 0 -3px 0 #ff682c;
}
</style>
